import React from 'react'
import styled from 'styled-components'
import { Box, Icon, ScreenReaderOnly, TextHeading } from '@ally/metronome-ui'
import { getAdobeIcon } from '../../adobeIcons'
import { AdobeResponse, MboxContent, MboxResponseObj } from '../../types'
import { List, ListItem } from './SharedStyles'
import { MboxTargetLink } from '../Shared'

const StyledMboxTargetLink = styled(MboxTargetLink)`
  display: inline-flex;
  white-space: normal;
`

const TipsMbox: React.FC<{ adobeTips: AdobeResponse<MboxContent>[] }> = ({
  adobeTips,
}) => {
  return (
    <>
      <ScreenReaderOnly>
        <TextHeading tag="h2" size="md">
          Tips and Opportunities
        </TextHeading>
      </ScreenReaderOnly>
      <List>
        {adobeTips.map((tip: AdobeResponse<MboxContent>, index) => {
          const mboxSetJson = tip.filter(
            item => item.action === 'setJson',
          )[0] as MboxResponseObj<MboxContent>
          const content = mboxSetJson.content[0]
          const {
            description,
            ctaHref,
            ctaNewTab,
            ctaLabel,
            iconColor,
            iconName,
          } = content as MboxContent
          const adobeIcon = getAdobeIcon(iconName)
          const adobeTipsKey = `tips-mbox-${index}`
          return (
            <ListItem
              key={adobeTipsKey}
              data-testid="tips-and-opportunities-item"
              data-track-mbox={tip[0].trackingName}
            >
              {adobeIcon && (
                <Icon
                  icon={adobeIcon}
                  unsupportedCustomWidth={18}
                  unsupportedCustomHeight={18}
                  fill={iconColor || 'plum'}
                  ariaHidden
                  mt="1px"
                  mr="xs"
                />
              )}
              <Box flex="1">
                <Box display="inline" mr="xs">
                  {description}
                </Box>
                <StyledMboxTargetLink
                  id={`tips-mbox-${index}`}
                  to={ctaHref}
                  text={ctaLabel}
                  ctaNewTab={ctaNewTab}
                />
              </Box>
            </ListItem>
          )
        })}
      </List>
    </>
  )
}

export default TipsMbox
